export class MembershipStatus {
  clientId: number;
  membershipDisplayName: string;
}
